import React from 'react'

interface PublishIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PublishIcon: React.FC<PublishIconProps> = ({
  color = '#000',
  gradient,
  width = 25,
  height = 20,
  alt = 'Publish icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 25 20'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M4.4.19a.625.625 0 11.897.87A11.974 11.974 0 002.77 4.997a12.814 12.814 0 00-.894 4.713c0 1.622.304 3.226.894 4.714a11.973 11.973 0 002.528 3.936.625.625 0 11-.896.871 13.223 13.223 0 01-2.794-4.347A14.063 14.063 0 01.625 9.71c0-1.777.334-3.537.982-5.173A13.223 13.223 0 014.4.19zm3.604 1.908a.625.625 0 11.888.879 8.641 8.641 0 00-1.86 2.846 9.125 9.125 0 00-.659 3.41c0 1.172.225 2.332.658 3.408a8.641 8.641 0 001.861 2.846.625.625 0 01-.888.879 9.89 9.89 0 01-2.132-3.258 10.375 10.375 0 01-.748-3.876c0-1.332.254-2.65.748-3.876a9.89 9.89 0 012.132-3.258zm8.428-.005a.616.616 0 01.876.005 9.899 9.899 0 012.114 3.258 10.45 10.45 0 01.742 3.876c0 1.332-.252 2.65-.742 3.876a9.899 9.899 0 01-2.114 3.258.616.616 0 01-.876.005.629.629 0 01-.005-.884 8.648 8.648 0 001.845-2.846 9.19 9.19 0 00.653-3.409 9.19 9.19 0 00-.653-3.409 8.648 8.648 0 00-1.845-2.846.629.629 0 01.005-.884zM20.882.19a.616.616 0 00-.877-.013.629.629 0 00-.013.883A11.985 11.985 0 0122.5 4.997c.585 1.488.887 3.092.887 4.713 0 1.622-.302 3.226-.887 4.714a11.984 11.984 0 01-2.508 3.936.629.629 0 00.013.884c.246.24.638.235.877-.013a13.236 13.236 0 002.77-4.347c.643-1.636.974-3.396.974-5.174 0-1.777-.33-3.537-.973-5.173A13.236 13.236 0 0020.882.19z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M15.125 9.7a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z'
      ></path>
    </svg>
  )
}

export default PublishIcon
